"use strict";import{tag as r}from"../custom-tag.js";export function globeIcon({height:a=16,width:e=16,hidden:l=!1,title:t="Globe"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <mask
        id="globe_svg__mask0_6875_6143"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m8.815 9.479h-3.424a13.4 13.4 0 0 0-2.299-7.725 8.83 8.83 0 0 1 5.723 7.725m-9.479-8.164v8.164H7.782c.13-4.076 1.647-7.5 3.554-8.164m0 9.349v8.02c-1.883-.65-3.388-4.004-3.554-8.02zm1.185 8.068v-8.068h3.685c-.13 4.123-1.742 7.547-3.685 8.068m0-9.253V3.268c1.967.521 3.555 4.028 3.685 8.21zM8.967 3.754a13.4 13.4 0 0 0-2.37 7.725H3.22a8.82 8.82 0 0 1 5.747-7.725m-5.747 8.91h3.377a13.35 13.35 0 0 0 2.37 7.57 8.8 8.8 0 0 1-5.747-7.57m11.849 7.57a13.26 13.26 0 0 0 2.322-7.57h3.424a8.8 8.8 0 0 1-5.723 7.57z"
        />
      </mask>
      <g mask="url(#globe_svg__mask0_6875_6143)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=globe.js.map
